<template>
	<div
		:class="[
			'field-wrapper',
			'dropdown',
			name,
			{
				open,
				disabled : disabled
			},
		]"
	>
		<fieldset ref="dropdownWrapper">
			<button
				ref="dropdownToggle"
				@click.stop.prevent="toggle"
				:class="[
					'dropdown-toggle',
					'dc-button',
					'dc-button--has-title',
					'dc-button--has-icon',
					{
						open: open,
					},
				]"
				:aria-controls="dropdownId"
				:aria-expanded="open" 
				:aria-disabled="disabled"
			>
				<legend :for="name">{{ currentLegendText }}</legend>
				<span class="menu-dots">
					<span class="dot top"></span>
					<span class="dot middle"></span>
					<span class="dot bottom"></span>
				</span>
			</button>
			<div
				ref="dropdownOptions"
				:id="dropdownId"
				:class="[
					'dropdown-wrapper',
					{
						open: open,
					},
				]"
				:aria-hidden="!open"
			>
				<OptionsList
					v-if="!hasHierarchy"
					:showAllOption="showAllOption"
					:checkedValues="checkedValues"
					:options="options"
					:fieldName="name"
					v-on:update-filter="choose"
					v-on:reset-filter="reset"
				/>
				<OptionsAccordion
					v-if="hasHierarchy"
					:showAllOption="showAllOption"
					:checkedValues="checkedValues"
					:options="options"
					:fieldName="name"
					v-on:update-filter="choose"
					v-on:reset-filter="reset"
				/>
			</div>
		</fieldset>
	</div>
</template>
<script>
import OptionsAccordion from './dropdown/OptionsAccordion';
import OptionsList from './dropdown/OptionsList';
import { Translatable } from '@dc-post-grid/mixins/Translatable';
export default {
	mixins: [Translatable],
	props: {
		disabled: {
			type: Boolean,
			required: false,
		},
		name: {
			type: String,
			required: true,
		},
		model: {
			type: Array,
			required: true,
		},
		label: {
			type: String,
			required: true,
		},
		options: {
			type: Array,
			required: true,
		},
		open: {
			type: Boolean,
			required: true,
		},
		initialSelection: {
			type: String,
			required: false,
		},
		multiselect: {
			type: Boolean,
			required: true,
		},
		showAllOption: {
			type: Boolean,
			required: true,
		},
		gridSettings: {
			type: Object,
			required: false,
			default: {},
		}
	},
	data() {
		return {
			checkedValues: [],
			legendText: '',
		};
	},
	computed: {
		dropdownId() {
			return 'dropdown-' + this.name;
		},
		hasHierarchy() {
			return typeof this.options[0].parent_term !== 'undefined';
		},
		currentLegendText() {
			return this.checkedValues.length === 1 && !this.multiselect ? this.legendText : this.label;
		},
	},
	methods: {
		toggle() {
			this.$emit('toggle-filter', this.name, this.dropdownId);
		},
		choose(newValue, newLabel) {
			this.$emit('update-filter', this.name, newValue, this.multiselect);
			if (!this.multiselect) {
				this.legendText = newLabel;
				this.toggle();
				return;
			}
			// If the gridSettings.close_filters_on_select prop is true, close the filter when selecting an option
			if (this.gridSettings.close_filters_on_select) {
				this.toggle();
			}
		},
		reset() {
			this.$emit('reset-filter', this.name);
			this.legendText = this.label;
			this.toggle();
		},
		handleClickToClose(e) {
			let count = 15;
			let element = e.target;
			let shouldClose = true;
			for (let i = 0; i < count; i++) {
				if (element.parentNode === null) break;
				element = element.parentNode;
				if (
					element.nodeName==='DIV' && 
					element.classList.contains('dropdown') && 
					element.classList.contains('open')
				) {
					shouldClose = false;
				}
			}
			if (shouldClose) this.toggle();
		},
		handleKeyToClose(e) {
			if (e.key === "Escape") this.toggle();
		},
		addEventListeners() {
			window.addEventListener('click', this.handleClickToClose);
			window.addEventListener('keydown', this.handleKeyToClose);
		},
		removeEventListeners() {
			window.removeEventListener('click', this.handleClickToClose);
			window.removeEventListener('click', this.handleKeyToClose);
		}
	},
	mounted() {
		if (!this.multiselect) {
			for (let i = 0; i < this.options.length; i++) {
				if (this.options[i].value !== this.initialSelection) continue;
				this.legendText = this.options[i].label;
			}
		}
		if (this.initialSelection) {
			this.checkedValues =
				typeof this.initialSelection === 'object'
					? Object.values(this.initialSelection)
					: [this.initialSelection];
		}
		if (this.legendText === '') {
			this.legendText = this.label;
		}
	},
	watch: {
		open(newVal) {
			if (newVal) {
				this.addEventListeners();
			} else {
				this.removeEventListeners();
			}
		},
		model(newVal) {
			this.checkedValues = Object.values({ ...newVal });
		},
		disabled(newVal) {
			if (newVal) {
				this.open = false
			}
		}
	},
	components: {
		OptionsList,
		OptionsAccordion,
	},
};
</script>
